import React from 'react';
import { NewVMStep8SC, AuthenticationSteps } from './NewBmStep8.style';
import Heading from 'components/Heading/Heading';
import { Grid, useMediaQuery } from '@mui/material';
import { H5, P } from 'components/reusable-css';
import Select from 'components/select';
import classes from './label-field.module.css';
import { useTranslation } from 'react-i18next';
import Loading from 'components/common/loading';

const NewBmStep8 = ({ formikProp, bmUpgrade = [], bmUpgradeLoading }) => {
  const { t } = useTranslation();
  const matches = useMediaQuery('(max-width:850px)');
  const width = matches ? '100%' : '33rem';
  const { setFieldValue, values } = formikProp;
  const selectStyling = {
    width,
    marginTop: '1.7rem',
  };

  const renderUpgradeOptions = (upgradeKey) => {
    const upgradeData = bmUpgrade?.[0]?.[upgradeKey];
    if (!upgradeData) return null;

    let select_array = upgradeData.items?.map((data) => ({
      value: data.id,
      text: t(`public/checkout/bm.${data.api_language_string}`, { monthly_price: data.price_monthly_usd }),
    }));

    select_array.unshift({
      value: '',
      text: 'Please select',
    });

    const handleChange = (e) => {
      let selectedPrice = upgradeData.items?.find((data) => data.id == e.target.value);
      if (selectedPrice?.price_monthly_usd) {
        let monthly_price = selectedPrice?.price_monthly_usd || 0;
        let yearly_price = selectedPrice?.price_yearly_usd || 0;
        setFieldValue(`prices.customize_server.${upgradeKey}`, {
          key: upgradeKey,
          price: monthly_price,
          yearly_price: yearly_price,
          name: selectedPrice?.api_language_string,
          id: selectedPrice?.id,
        });
      } else {
        if (values.prices?.customize_server?.[upgradeKey]) {
          const updatedMonthlyCustomizeServer = { ...values.prices.customize_server };
          delete updatedMonthlyCustomizeServer[upgradeKey];
          setFieldValue(`prices.customize_server`, updatedMonthlyCustomizeServer);
        }
      }
    };

    return (
      <Grid className={classes.main} container key={upgradeKey}>
        <Grid item xs={12} sm={5} md={4} lg={4} xl={3} className="pr-5">
          <H5 className={classes.label}>{t(`public/checkout/bm.${upgradeData.api_language_string}`)}</H5>
        </Grid>
        <Grid item xs={12} sm={7} lg={8} xl={9}>
          <Select styling={selectStyling} options={select_array} onChange={handleChange} />
        </Grid>
      </Grid>
    );
  };

  const upgradeKeys = [];
  bmUpgrade.forEach((obj) => {
    Object.keys(obj).forEach((key) => {
      upgradeKeys.push(key);
    });
  });

  return (
    <NewVMStep8SC>
      <Heading name={'bm/instance/create.step8_string1'}>
        {bmUpgradeLoading ? (
          <Loading />
        ) : (
          <AuthenticationSteps>
            {bmUpgrade?.length > 0 ? (
              <>
              <P>{t('bm/instance/create.step8_string3')}</P>
                {upgradeKeys.map(renderUpgradeOptions)}
              </>
            ) : (
              <P>{t('public/checkout/bm.step5_string2')}</P>
            )}
          </AuthenticationSteps>
        )}
      </Heading>
    </NewVMStep8SC>
  );
};

export default NewBmStep8;
